/**
 * chat_widget/src/widget/ui/ChatPanel.tsx
 */

import Header from "./Header";
import Footer from "./Footer";
import Feed from "./Feed";
import type { Msg } from "../types/messagesTypes";
import type { FormActiveType, LeadFormProps } from "../types/formTypes";
import type { RefObject } from "react";
import { AttachedCar } from "./VehicleSheet/AttachedCar";

export function ChatPanel({
  onClose,
  actions,
  input,
  setInput,
  loading,
  messages,
  lang,
  bodyRef,
  onSend,
  selectedCar,
  setSelectedCar,
  onMoreInfo,
  onMoreInfoGarage,
  onBookTestDrive,
  getVehicleDetails,
  refreshSession,
  clearAttachedCar,
  scrollToBottom,
  agentName,
  attachedCar,
  formActive,
  setFormActive,
  onBooked,
  avatar
}: {
  avatar: string | null;
  agentName: string;
  onClose: () => void;
  input: string;
  setInput: (text: string) => void;
  loading: boolean;
  messages: Msg[];
  lang: string;
  attachedCar: any;
  formActive: FormActiveType | null;
  bodyRef: RefObject<HTMLDivElement | null>;
  getVehicleDetails: (carId: string) => void;
  selectedCar: any;
  onMoreInfoGarage: () => void;
  onMoreInfo: (carId: string) => void;
  onBookTestDrive: (carId: string) => void;
  actions: [];
  setSelectedCar: React.Dispatch<React.SetStateAction<any>>;
  onSend: () => void;
  refreshSession: () => void;
  clearAttachedCar: () => void;
  scrollToBottom: () => void;
  setFormActive: (v: FormActiveType | null) => void;
  onBooked: LeadFormProps["onBooked"];
}) {
  return (
    <div className="vcw-panel" role="dialog" aria-label={agentName}>
      <Header
        onClose={onClose}
        agentName={agentName}
        refreshSession={refreshSession}
      />
      <Feed
        messages={messages}
        lang={lang}
        loading={loading}
        bodyRef={bodyRef}
        onMoreInfo={onMoreInfo}
        onBookTestDrive={onBookTestDrive}
        getVehicleDetails={getVehicleDetails}
        selectedCar={selectedCar}
        setSelectedCar={setSelectedCar}
        actions={actions}
        onSend={onSend}
        refreshSession={refreshSession}
        onMoreInfoGarage={onMoreInfoGarage}
        attachedCar={attachedCar}
        clearAttachedCar={clearAttachedCar}
        formActive={formActive}
        scrollToBottom={scrollToBottom}
        setFormActive={setFormActive}
        onBooked={onBooked}
        avatar={avatar}
      />
      <Footer
        lang={lang}
        setInput={setInput}
        input={input}
        onSend={onSend}
        loading={loading}
        formActive={formActive}
        selectedCar={selectedCar?._id}
      />
      {attachedCar?._id && !selectedCar?._id && !formActive?.name ? (
        <AttachedCar
          getVehicleDetails={getVehicleDetails}
          car={attachedCar}
          clearAttachedCar={clearAttachedCar}
        />
      ) : null}
    </div>
  );
}
